module.exports = __webpack_public_path__ + "static/media/add.f518abff.gif";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/help/add.gif
// module id = 424
// module chunks = 0